import type { IconProps } from "@/types/IconProps";

export function Security(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <g clipPath="url(#clip0_28_202)">
        <path d="M16.25 8.535c-1.455-.045-3.108-.871-4.251-1.865-1.137.987-2.793 1.82-4.249 1.865v4.255c0 1.365.469 2.35 1.206 3.105.752.77 1.818 1.334 3.055 1.764 1.227-.433 2.285-.995 3.033-1.763.737-.757 1.206-1.741 1.206-3.106zm1.5 4.255c0 1.76-.625 3.12-1.632 4.153-.986 1.011-2.305 1.677-3.659 2.15l-.006.002c-.294.1-.612.096-.904-.009l-.012-.004h-.005v-.002c-1.351-.468-2.666-1.13-3.65-2.137C6.876 15.91 6.25 14.55 6.25 12.79V8.415c0-.364.145-.714.402-.971l.102-.092c.245-.2.552-.312.871-.312l.193-.006c.987-.074 2.27-.685 3.213-1.508l.007-.005a1.48 1.48 0 0 1 1.924 0l.007.005c1.01.884 2.398 1.514 3.406 1.514.319 0 .627.112.871.312l.102.092.09.1c.2.245.312.552.312.871z"></path>
      </g>
      <defs>
        <clipPath id="clip0_28_202">
          <path fill="#fff" d="M4.5 4.666h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
